import { Facebook, Instagram, MessageCircle } from "lucide-react";
import { useStore } from "@/components/StoreContext";
import { getSocialHrefs } from "@/lib/social-links";

export function StoreSocialLinks({ tone = "dark" }: { tone?: "dark" | "light" }) {
  const { storefrontSettings } = useStore();
  const hrefs = getSocialHrefs(storefrontSettings.socialLinks);
  const links = [
    { key: "facebook", label: "ChamakPatti on Facebook", href: hrefs.facebook, Icon: Facebook },
    { key: "instagram", label: "ChamakPatti on Instagram", href: hrefs.instagram, Icon: Instagram },
    { key: "whatsapp", label: "ChamakPatti on WhatsApp", href: hrefs.whatsapp, Icon: MessageCircle },
  ].filter(item => item.href);
  if (!links.length) return null;

  const colors = tone === "dark"
    ? "border-white/30 text-[#f7f5ef] hover:bg-white/10 focus-visible:ring-[#d5aa91]"
    : "border-[#9a8b80] text-[#49352f] hover:bg-[#eee9df] focus-visible:ring-[#815348]";

  return <nav aria-label="ChamakPatti social links" className="flex flex-wrap items-center gap-2">
    {links.map(({ key, label, href, Icon }) => <a
      key={key}
      href={href!}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      title={label}
      className={`inline-flex h-11 w-11 items-center justify-center rounded-full border transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ${colors}`}
      data-testid={`social-link-${key}`}
    >
      <Icon size={17} strokeWidth={1.7} aria-hidden="true"/>
      <span className="sr-only">{label}</span>
    </a>)}
  </nav>;
}
